<template>
  <div id="UserSubsegmentManager">
    <span
      @click="toggleSubsegment(subItem)"
      class="span--subsegment"
      v-for="subItem in mergedArrays"
      :key="subItem.description"
      :class="[checkSelected(subItem) ? 'item--active' : '']"
    >{{subItem.description}}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mergedArrays: []
    };
  },
  props: {
    subsegments: {
      type: Array,
      default: [],
      required: false
    },
    selectedSubsegments: {
      type: Array,
      required: false
    }
  },
  watch: {
    subsegments() {
      this.mergeArrays();
    }
  },
  mounted() {
    this.mergeArrays();
  },
  methods: {
    mergeArrays() {
      if(this.subsegments && this.selectedSubsegments){
        this.mergedArrays = [
          ...new Set([
            ...this.subsegments,
            ...this.selectedSubsegments.filter(item => item.canonical != 1)
          ])
        ];
      }
    },
    toggleSubsegment(item) {
      this.$emit("updateSelectedSubsegments", item);
    },
    checkSelected(item) {
      let selectedSubsegments = this.$store.state.siteActive.segment
        .subSegments;
      let findSubsegment = this.$store.state.siteActive.segment.subSegments.findIndex(
        selected => selected.description == item.description
      );
      if (findSubsegment < 0) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped>
.span--subsegment {
  background-color: #f8f8f8;
  color: #9a9a9a;
  height: 32px;
  padding: 2px 24px;
  border-radius: 20px;
  display: inline-block;
  cursor: pointer !important  ;
  margin: 10px 10px 0 0;
  border: 1px solid transparent;
}
.item--active {
  border: 1px solid var(--main-color);
  color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/UserSubsegmentManager.vue